var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('a',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"href":"/area-research/feedback-form"}},[_vm._v("We want your feedback")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }